// U-5 placeholder. Flow напрямую сюда не ведёт — для backward-compat
// (email/push deep-link в Sprint 6+). Spec: docs/specs/sprint-4/stage-4-frontend.md §4.5.

import { Link } from 'wouter';

export function UploadDone() {
  return (
    <div className="mx-auto flex min-h-dvh max-w-md flex-col items-center justify-center gap-3 p-6">
      <div className="text-3xl">✅</div>
      <h1 className="text-2xl font-semibold">Сохранено</h1>
      <p className="text-center text-sm text-muted-foreground">
        Полная Главная и графики — в Sprint 5.
      </p>
      <Link href="/upload/history" className="text-sm font-semibold text-primary-text">
        Открыть историю →
      </Link>
    </div>
  );
}
